import React from 'react';
// import JssProvider from 'react-jss/lib/JssProvider';
import { createTheme } from '@material-ui/core/styles'
import { fetchUtils, Admin, Layout, Resource } from 'react-admin';
import { 
    ListGuesser,
    // EditGuesser
 } from 'react-admin';
import { Route } from 'react-router-dom';

import RegistrationForm from './components/Registration.v2.jsx';

import dataProvider from './dataProvider.jsx';
import authProvider from './authProvider.jsx';
import { API_BASE_URL } from './config.jsx';

import MyMenu from './MyMenu.jsx';
import UserList from './components/UserList.jsx';
import UserEdit from './components/UserEdit.jsx';
import RoleList from './components/RoleList.jsx';

import PreResetPassword from './components/PreResetPassword.jsx';
import ResetPassword from './components/ResetPassword.jsx';

import HEXSelectorUserCreate from './components/HEXSelectorUserCreate.jsx';
import HEXSelectorUserEdit from './components/HEXSelectorUserEdit.jsx';

import { HEXSelectorUserReportingList, HEXSelectorCrashReportDetail } from './components/HEXSelectorUserReportingList.jsx';
import { HEXSelectorClientTelemetricsList } from './components/HEXSelectorClientTelemetrics.jsx';
import { HEXSelectorPendingRequestsList } from './components/HEXSelectorPending.jsx';
import {
    HEXSelectorPlateCreate,
    HEXSelectorPlateEdit,
    HEXSelectorPlateList,
    HEXSelectorPlateListsList,
    HEXSelectorPlateListsCreate,
    HEXSelectorPlateListsEdit,
    HEXSelectorPlateListsShow,
    HEXSelectorPlateTypeListsList,
    HEXSelectorPlateTypeListsEdit,
    HEXSelectorPlateTypeListsShow,
    HEXSelectorPlateTypeListsCreate,
} from './components/HEXSelectorPlateLists.jsx'

import PhecalcUserEdit from './components/PhecalcUserEdit.jsx';
import { 
    HEXSelectorSegmentCollectionList,
    HEXSelectorSegmentCollectionEdit,
    HEXSelectorSegmentCollectionCreate,
    HEXSelectorPandoraConfigList,
    HEXSelectorPandoraConfigEdit,
    HEXSelectorPandoraConfigCreate,
    HEXSelectorProductList,
    HEXSelectorProductEdit,
    HEXSelectorProductCreate,
    HEXSelectorApplicationList,
    HEXSelectorApplicationEdit,
    HEXSelectorApplicationCreate,
    HEXSelectorSegmentList,
    HEXSelectorSegmentEdit,
    HEXSelectorSegmentCreate,
} from './components/HEXSelectorSegmentList.jsx';
import { RegionalSettingsList, RegionalSettingsCreate } from './components/RegionalSettings.jsx';
import { UserActivityList, VIPCustomerList,VIPCustomerEdit,VIPCustomerCreate } from './components/UserActivity.jsx';
import { LLMCreate, LLMEdit, LLMList } from './components/LocalLicenseManagers.jsx';
import { AHRIList, AHRIEdit, AHRICreate} from './components/AHRIList';
import { PlatePandoraList, PlatePandoraEdit} from './components/PlatePandoraList';
// import Color from '@material-ui/core/colors'


export const DanfossRed = { main: '#EE1B22'};
export const DanfossRedHex = '#EE1B22';

const theme = createTheme({
    palette: {
      type: 'light',
      secondary: DanfossRed
    },
  });

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json'});
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}

export {httpClient};

const MyLayout = (props) => <Layout
    {...props}
    menu={MyMenu}
/>;

const escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
let classCounter = 0;

// Heavily inspired of Material UI:
// @see https://github.com/mui-org/material-ui/blob/9cf73828e523451de456ba3dbf2ab15f87cf8504/src/styles/createGenerateClassName.js
// The issue with the MUI function is that is create a new index for each
// new `withStyles`, so we handle have to write our own counter
export const generateClassName = (rule, styleSheet) => {
    classCounter += 1;

    if (process.env.NODE_ENV === 'production') {
        return `c${classCounter}`;
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
        let prefix = styleSheet.options.classNamePrefix;
        // Sanitize the string as will be used to prefix the generated class name.
        prefix = prefix.replace(escapeRegex, '-');

        if (prefix.match(/^Mui/)) {
            return `${prefix}-${rule.key}`;
        }

        return `${prefix}-${rule.key}-${classCounter}`;
    }

    return `${rule.key}-${classCounter}`;
};

const App = () => (
    // <JssProvider generateClassName={generateClassName}>
        <Admin title="HEXSelector Administration"
            // dashboard={Statistics}
            theme={theme}
            layout={MyLayout}
            customRoutes={[
                <Route exact path="/registration" render={() => <RegistrationForm />} noLayout />,
                <Route exact path="/preresetpassword" render={() => <PreResetPassword />} noLayout />,
                <Route exact path="/resetpassword" render={() => <ResetPassword />} noLayout />,
            ]}
            dataProvider={dataProvider(API_BASE_URL, httpClient)}
            authProvider={authProvider}
            requireAuth
            >
            <Resource name="users" list={UserList} edit={UserEdit} />
            <Resource name="statistics" list={ListGuesser} />
            <Resource name="roles" list={RoleList} />
            <Resource name="countries" />
            <Resource name="HEXSelector/Users/HSCreate"></Resource>
            <Resource name="HEXSelector/Users/Companies"></Resource>
            <Resource name="ScheduledTask/VIPCustomers"
                list={VIPCustomerList}
                edit={VIPCustomerEdit}
                create={VIPCustomerCreate}
            />
            <Resource name="HEXSelector/RegionalSettings/DeliveryConcepts"></Resource>
            <Resource name="HEXSelector/RegionalSettings/CustomPortfolios"></Resource>
            <Resource name="HEXSelector/RegionalSettings/FluidLists"></Resource>
            <Resource name="HEXSelector/RegionalSettings/LocalPriceLists"></Resource>
            <Resource name="HEXSelector/RegionalSettings/ReadinessAccess"></Resource>
            <Resource name="HEXSelector/RegionalSettings"
                list={RegionalSettingsList}
                create={RegionalSettingsCreate}
            />
            <Resource name="ScheduledTask/UserActivities"
                list={UserActivityList} />
            <Resource name="HEXSelector/Reporting"
                list={HEXSelectorUserReportingList}
                show={HEXSelectorCrashReportDetail} />
            <Resource name="HEXSelector/Telemetrics" 
                list={HEXSelectorClientTelemetricsList}
            />
            <Resource name="HEXSelector/Reporting/Users" />
            <Resource name="HEXSelector/Reporting/Versions" />
            <Resource name="HEXSelector/Reporting/Types" />
            <Resource name="HEXSelector/Reporting/TopOfStack" />
            <Resource name="HEXSelector/Users/History" />
            <Resource name="HEXSelector/AccountRequestSegments" />
            <Resource name="HEXSelector/Users"
                create={HEXSelectorUserCreate}
                edit={HEXSelectorUserEdit} />
            <Resource name="HEXSelector/PendingUsers"
                list={HEXSelectorPendingRequestsList}
            />
            <Resource name="HEXSelector/PlateListsTree" />
            <Resource name="HEXSelector/PlateLists" 
                list={HEXSelectorPlateListsList}
                create={HEXSelectorPlateListsCreate}
                edit={HEXSelectorPlateListsEdit}
                show={HEXSelectorPlateListsShow}
            />
            <Resource name="HEXSelector/PlateTypeLists" 
                list={HEXSelectorPlateTypeListsList}
                show={HEXSelectorPlateTypeListsShow}
                edit={HEXSelectorPlateTypeListsEdit}
                create={HEXSelectorPlateTypeListsCreate}
            />
            <Resource name="HEXSelector/PlateTypeNames"
                list={HEXSelectorPlateList}
                create={HEXSelectorPlateCreate}
                edit={HEXSelectorPlateEdit}
            />
            <Resource name="HEXSelector/ExchangerTypes" />
            <Resource name="HEXSelector/DutyTypes" />
            <Resource name="HEXSelector/LicenseTypes" />
            <Resource name="HEXSelector/LicenseStatuses" />
            <Resource name="HEXSelector/UserStatuses" />
            <Resource name="HEXSelector/OEM" />
            <Resource name="HEXSelector/ReleaseBranches" />
            <Resource name="HEXSelector/SegmentCollectionsTree" />
            <Resource name="HEXSelector/SegmentCollections" 
                list={HEXSelectorSegmentCollectionList}
                edit={HEXSelectorSegmentCollectionEdit}
                create={HEXSelectorSegmentCollectionCreate}
            />
            <Resource name="HEXSelector/Segments" 
                list={HEXSelectorSegmentList}
                edit={HEXSelectorSegmentEdit}
                create={HEXSelectorSegmentCreate}
            />
            <Resource name="HEXSelector/Applications" 
                list={HEXSelectorApplicationList}
                edit={HEXSelectorApplicationEdit}
                create={HEXSelectorApplicationCreate}
            />
            <Resource name="HEXSelector/Products" 
                list={HEXSelectorProductList}
                edit={HEXSelectorProductEdit}
                create={HEXSelectorProductCreate}
            />
            <Resource name="HEXSelector/PandoraConfigs" 
                list={HEXSelectorPandoraConfigList}
                edit={HEXSelectorPandoraConfigEdit}
                create={HEXSelectorPandoraConfigCreate}
            />
            <Resource name="HEXSelector/PlatePandora" 
                list={PlatePandoraList}
                edit={PlatePandoraEdit}
            />
            <Resource name="HEXSelector/LocalLicenseManagers" 
                list={LLMList}
                edit={LLMEdit}
                create={LLMCreate}
            />
            <Resource name="HEXSelector/AppFluidRules" />
            <Resource name="HEXSelector/SegFluidRules" />
            <Resource name="HEXSelector/ProdFluidRules" />
            <Resource name="HEXSelector/LocalLicenseManagers/Segments" />
            <Resource name="HEXSelector/LocalLicenseManagers/HexTypes" />


            <Resource name="HEXSelector/DiscountUserLevels" />
            <Resource name="HEXSelector/SpecialFileCollections" />

            <Resource name="HEXSelector/ahri"
                list={AHRIList}
                edit={AHRIEdit}
                create={AHRICreate}
            />
            <Resource name="HEXSelector/ahri/current" />
            <Resource name="HEXSelector/ahri/test" />
            <Resource name="HEXSelector/ahri/config" />

            <Resource name="Phecalc/Users" edit={PhecalcUserEdit} />
            <Resource name="Phecalc/Databases" />
        </Admin>
    // </JssProvider>
);
export default App;
